//////////////////
// Entry Point  //
//////////////////

import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "raf/polyfill";

import { ready } from "@util/dom";
import onmount from "onmount";

// app ...
import "./App";

/**
 * Client-side entry point of the V2 React app: the "main" Vite build (see
 * `vite.config.ts`), loaded via `SsrJsHelper::renderBundles()` on every page whose
 * view/controller sets the `useReact` view var.
 * Loads polyfills, then `./App` (which wires up the Redux/React Query
 * providers and the `onmount` handlers that mount individual components), then triggers
 * `onmount` once the DOM is ready so both React mounts and plain-DOM behaviors run.
 *
 * Part of the V2 React App component — see docs/wiki/System/v2/frontend/v2-react-app.md.
 */

// at the end, trigger onmount to bind elements and react
ready(onmount);
